import { jsx as _jsx } from "react/jsx-runtime";
import { SavedSearchButton } from '@aviv-saved-search/shared/Components';
import { mapSearchModelToQueryString } from '@aviv-search/transformers';
import { useLocale } from '@aviv-unified-frontend/runtime/i18n';
import { Box } from '@gemini/core';
import { useBrandConfiguration } from '../../brands/context';
import { useStageConfiguration } from '../../hooks/useStageConfiguration';
export const AlertButtonTestId = 'serp-alert-button-testid';
export const AlertButton = ({ searchModel, origin }) => {
    const { mfes: { savedSearchBrandId }, } = useBrandConfiguration();
    const { stage } = useStageConfiguration();
    const { language } = useLocale();
    return savedSearchBrandId && searchModel ? (_jsx(Box, { testId: AlertButtonTestId, children: _jsx(SavedSearchButton, { searchModel: searchModel, searchUrl: mapSearchModelToQueryString(searchModel), brand: savedSearchBrandId, locale: language, stage: stage, type: "btn", origin: origin }) })) : null;
};
